import { useState, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { getFeriadosDelAnio } from '../services/api.service.js';
import { getFechasInvalidas } from '../services/instancias.service.js';
import BurbujasLoader from './UIElements/BurbujasLoader';
import Box from '@mui/material/Box';
import { getFechasInhabilitadas } from '../services/fechas_inhabilitadas.service.js';
import { getFechasInhabilitadasFin } from '../services/fechas_inhabilitadas_fin.service.js';

const Fecha = ({ mensaje, getFecha, id, fieldFecha, value, esCampusCordoba, fechaHastaAnterior, fechaDesdeActual, instanciasExistentes, ...props }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [feriados, setFeriados] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [fechasInvalidas, setFechasInvalidas] = useState([]) // fechas que no cumplen con las restricciones
  const [fechasInhabilitadas, setFechasInhabilitadas] = useState([]) // fechas inhabilitadas manualmente
  const [fechasInhabilitadasFin, setFechasInhabilitadasFin] = useState([]) // fechas inhabilitadas de fin de cursada


  useEffect(() => {
    (async () => {
      try {
        // const feriados = await getFeriadosDelAnio();
        setIsLoading(true)

        //Obtener año actual 
        dayjs.extend(utc);
        dayjs.extend(timezone);

        const ahoraArgentina = dayjs().tz('America/Argentina/Buenos_Aires');
        const anioActual = ahoraArgentina.year().toString();
        const anioSiguiente = ahoraArgentina.add(1, 'year').year().toString();
        const fechasInvalidas2025 = await getFechasInvalidas(anioActual)
        const fechasInvalidas2026 = await getFechasInvalidas(anioSiguiente)
        const fechasInhabilitadas = await getFechasInhabilitadas()
        const fechasInhabilitadasFinData = await getFechasInhabilitadasFin()


        const feriados = await getFeriadosDelAnio();
        setFeriados(feriados);


        setFechasInvalidas([...fechasInvalidas2025, ...fechasInvalidas2026])
        setFechasInhabilitadas(fechasInhabilitadas)
        setFechasInhabilitadasFin(fechasInhabilitadasFinData)

      } catch (error) {
        console.error('Error al obtener la matriz de fechas:', error);
      } finally {
        setIsLoading(false)
      }
    })();
  }, []);

  const handleDateChange = (newDate) => {
    const formattedDate = newDate ? dayjs(newDate).format('YYYY-MM-DD') : null;
    setSelectedDate(newDate);
    getFecha(formattedDate, id, fieldFecha);
  };

  const shouldDisableDate = (date) => {
    const today = dayjs();
    const isWeekend = date.day() === 0 || date.day() === 6;
    const isBeforeToday = date.isBefore(today, 'day');

    if (isWeekend || isBeforeToday) {
      return true;
    }

    if (fieldFecha === "fechaCursadaDesde") {
      const fechaAValidar = dayjs(date).format('YYYY-MM-DD').split("-");

      const stringFecha = `${fechaAValidar[0]}-${fechaAValidar[1]}-${fechaAValidar[2]}`;

      if (fechasInvalidas.map(element => element.calendario_fecha).includes(stringFecha)) return true;

      if (feriados.map(element => element.fecha).includes(stringFecha)) return true;

      if (fechasInhabilitadas.map(element => element.fecha).includes(stringFecha)) return true;

      // Validación Campus Córdoba: 7 días después de la anterior
      if (esCampusCordoba && fechaHastaAnterior) {
        const minFecha = dayjs(fechaHastaAnterior).add(8, 'day');
        if (date.isBefore(minFecha, 'day')) return true;
      }

      // Validación Campus Córdoba contra la Base de Datos (huecos y margen)
      if (esCampusCordoba && instanciasExistentes && instanciasExistentes.length > 0) {
        for (const inst of instanciasExistentes) {
          if (!inst.fecha_inicio_curso || !inst.fecha_fin_curso) continue;

          const dbInicio = dayjs(inst.fecha_inicio_curso);
          const dbFin = dayjs(inst.fecha_fin_curso);

          const dbInicioMargin = dbInicio.subtract(7, 'day');
          const dbFinMargin = dbFin.add(7, 'day');

          if (
            (date.isAfter(dbInicioMargin, 'day') || date.isSame(dbInicioMargin, 'day')) &&
            (date.isBefore(dbFinMargin, 'day') || date.isSame(dbFinMargin, 'day'))
          ) {
            return true;
          }
        }
      }

    }

    if (fieldFecha === "fechaCursadaHasta") {
      const fechaAValidar = dayjs(date).format('YYYY-MM-DD');

      if (feriados.map(element => element.fecha).includes(fechaAValidar)) return true;

      if (fechasInhabilitadasFin.map(element => element.fecha).includes(fechaAValidar)) return true;

      // Validación Campus Córdoba: Máximo 90 días desde el inicio y margen BD
      if (esCampusCordoba && fechaDesdeActual) {
        const startDate = dayjs(fechaDesdeActual);
        let maxAllowedDate = startDate.add(90, 'day');

        if (instanciasExistentes && instanciasExistentes.length > 0) {
          let instSiguienteDb = null;
          // Buscar la instancia futura más próxima
          for (const inst of instanciasExistentes) {
            if (!inst.fecha_inicio_curso || !inst.fecha_fin_curso) continue;

            const dbInicio = dayjs(inst.fecha_inicio_curso);
            // Si el inicio de la de BD es futuro respecto a nuestro startDate
            if (dbInicio.isAfter(startDate, 'day')) {
              const prevMargin = dbInicio.subtract(8, 'day');
              if (prevMargin.isBefore(maxAllowedDate, 'day')) {
                maxAllowedDate = prevMargin;
              }
            }
          }
        }

        if (date.isAfter(maxAllowedDate, 'day')) return true;
        if (date.isBefore(startDate, 'day')) return true;
      }
    }

    return false;
  };


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      {/* Contenedor principal para posicionar el spinner encima */}
      <Box sx={{ position: 'relative', width: '100%' }}>
        <div className='fecha-container'>
          <Typography variant="body1" className='fecha-label'>{mensaje}</Typography>
          <DatePicker
            sx={{ width: '100%', height: '100%' }}
            value={value ? dayjs(value) : null}
            onChange={handleDateChange}
            slots={{
              textField: (params) => <TextField {...params} helperText={params?.inputProps?.placeholder} />, // Mantenemos TextField
            }}
            // inputFormat="DD/MM/YYYY" // inputFormat está obsoleto, format es el actual
            format="DD/MM/YYYY"
            shouldDisableDate={shouldDisableDate}
            className='fecha-picker'
            disabled={isLoading} // Deshabilitar el DatePicker mientras carga
            PopperProps={{
              placement: "bottom-start",
              modifiers: [
                {
                  name: "flip",
                  enabled: true,
                  options: {
                    altBoundary: true,
                    rootBoundary: "viewport",
                    padding: 8,
                  },
                },
                {
                  name: "preventOverflow",
                  enabled: true,
                  options: {
                    altAxis: true,
                    altBoundary: true,
                    tether: true,
                    rootBoundary: "viewport",
                    padding: 8,
                  },
                },
              ],
            }}
          />
        </div>

        {/* Spinner de carga superpuesto */}
        {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.7)', // Fondo semitransparente opcional
              zIndex: 10, // Asegurar que esté por encima
              borderRadius: 'inherit', // Si el contenedor tiene bordes redondeados
            }}
          >
            <BurbujasLoader />
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default Fecha;